import { SyncExternalStore } from '@egr/xbox/utils/SyncExternalStore';

interface BottomSheetState {
    bottomSpacing: boolean;
}

class BottomSheetStore extends SyncExternalStore<BottomSheetState> {
    constructor() {
        super({
            bottomSpacing: false,
        });
    }

    public setBottomSpacing(bottomSpacing: boolean) {
        this.updateState({ bottomSpacing });
    }
}

export const bottomSheetStore = new BottomSheetStore();
